import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth';

/**
 * Allows navigation only for members/owners of the admin Entra group (resolved
 * via AuthService.isAdmin). Everyone else is redirected to the dashboard.
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth
    .isAdmin()
    .pipe(
      map((isAdmin) => (isAdmin ? true : router.createUrlTree(['/dashboard']))),
    );
};
